import { useNavigate } from "react-router-dom"

// UI components
import { CosmosButton, CosmosIconDelete, CosmosText } from "@cosmos/web/react"
import VCarbLogo from "../../assets/images/vcarb-logo-2.png"

// Returns the markup and functionality for the guestgroup rows
export default function GroupRow({ id, eventID, name, invite_code, maximum_guests, guest_count }) {
	// Make an instance of the useNavigate function from the router
	const navigate = useNavigate()

	return (
		<div className="thosp-guestgroup-row">
			<div className="guestgroup-row-name">
				<div className="row-logo">
					<img
						src={VCarbLogo}
						alt="Visa Cash App Racing Bulls"
					/>
				</div>
				<CosmosText
					appearance="dark"
					size="small">
					{name}
				</CosmosText>

				<CosmosText
					appearance="dark"
					size="x-small">
					Submitted {guest_count}/{maximum_guests} guest{guest_count !== 1 ? "s" : ""}
				</CosmosText>

				<CosmosText
					appearance="dark"
					size="x-small"
					kind="subtle"
					className="guestgroup-row-code-link"
					onClick={() =>
						window.location.hostname == "localhost"
							? window.open(`http://${window.location.hostname}:3000/event-registration?inviteID=${invite_code}`)
							: window.open(`https://${window.location.hostname}/event-registration?inviteID=${invite_code}`)
					}>
					{invite_code}
				</CosmosText>

				<div className="thosp-tab-navigation">
					<CosmosButton
						appearance="dark"
						kind="secondary"
						size="small"
						shape="rectangle"
						onClick={() => navigate(`/event/${eventID}/group/${id}/edit`)}>
						Edit
					</CosmosButton>

					<CosmosButton
						kind="primary"
						appearance="dark"
						size="small"
						shape="square"
						onClick={() => navigate(`/event/${eventID}/group/${id}/delete`)}>
						<CosmosIconDelete />
					</CosmosButton>
				</div>
			</div>
		</div>
	)
}
